// ПОДПИСЬ ПРИЛОЖЕНИЯ SCRIPTERA A В ЗАПРОСАХ (ТЗ ~/projects/ADM-ROOT-TZ.md §10 п.3).
//
// Приложение админки шлёт в User-Agent свою подпись. Две формы, обе принимаются:
//   • a119 и старше: `ScripteraAdmNative/<сборка> ScripteraApp/0.2 ScripteraAdm/0.1`;
//   • новые сборки: `ScripteraAdm/<версия>` — без `ScripteraApp`.
// Сайт по подписи только РАСПОЗНАЁТ платформу в ручках, которые зовёт приложение (пуш-токен — чьё устройство,
// язык — без валюты, устройства клиента — «приложение»); страниц под приложение у сайта нет.
// Чистый модуль (тест app-ua.test.ts).

/** Подпись Scriptera A в User-Agent (обе формы). */
const ADM_UA = /\bScripteraAdm(?:Native)?\//;

/** Запрос пришёл из приложения Scriptera A. */
export function isAdmAppUa(ua: string | null | undefined): boolean {
  return !!ua && ADM_UA.test(ua);
}

/** Запрос пришёл из нашего приложения — клиентского (`ScripteraApp`) или Scriptera A. */
export function isOurAppUa(ua: string | null | undefined): boolean {
  return !!ua && (ua.includes('ScripteraApp') || isAdmAppUa(ua));
}
